module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAFVBMVEUAAAAre8sre8sre8sre8sre8sre8v/hWABAAAABnRSTlMA66uAVBZg/lnaAAAAPUlEQVQI12NQSwOCJAYGhkAQQxTIYAExHBiAQA0sA5IDy4DkQDJgkJbGQAQDiFAZyTApAygjGcgGyxmAGQBBzRRHSn9CmgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_screen.png
// module id = Zjs4
// module chunks = 9